import {
  Component,
  ViewChild,
  ElementRef,
  Input,
  EventEmitter,
  Output,
  OnDestroy,
  AfterViewInit,
  ChangeDetectorRef,
  ViewEncapsulation
} from '@angular/core';
import * as uuid from 'uuid';

import $ from 'jquery';
import 'jquery-datetimepicker';
import { NgForm, NgModel } from '@angular/forms';
import { DeviceDetectorService } from 'ngx-device-detector';
// Document: https://xdsoft.net/jqplugins/datetimepicker/

@Component({
  selector: 'sd-date-picker-control',
  templateUrl: './date-picker-control.component.html',
  styleUrls: ['../../assets/css/form.scss', './date-picker-control.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DatePickerControlComponent implements OnDestroy, AfterViewInit {
  private isMobileOrTablet = false;
  private initialized = false;
  private pDate: any;
  pMinDate: any = null;
  pMaxDate: any = null;
  name = uuid.v4();
  @Input() form: NgForm;
  @Input() type: 'datetime' | 'date' | 'time' = 'datetime';
  @Input() disabled = false;
  @Input() required = false;
  @Input() label: string;
  @Input() set minDate(date: string | Date | number) {
    if (!Date.isDate(date)) {
      this.pMinDate = null;
    } else {
      this.pMinDate = Date.toFormat(date, 'yyyy/MM/dd HH:mm');
    }
    this.setOption();
  }
  @Input() set maxDate(date: string | Date | number) {
    if (!Date.isDate(date)) {
      this.pMaxDate = null;
    } else {
      this.pMaxDate = Date.toFormat(date, 'yyyy/MM/dd HH:mm'); // this.datePipe.transform(date, 'yyyy/MM/dd HH:mm');
    }
    this.setOption();
  }
  @Input() validator: (value: any) => string | Promise<string>;
  // tslint:disable-next-line: no-output-native
  @Output() change = new EventEmitter();
  @Output() sdChange = new EventEmitter();
  date: string;

  @Input() set model(val: any) {
    if (!Date.isDate(val)) {
      this.pDate = null;
    } else {
      if (this.type === 'datetime') {
        this.pDate = Date.toFormat(val, 'dd/MM/yyyy HH:mm');
      } else if (this.type === 'date') {
        this.pDate = Date.toFormat(val, 'dd/MM/yyyy');
      } else {
        this.pDate = Date.toFormat(val, 'HH:mm');
      }
    }
    if (this.initialized) {
      this.onChanges();
    }
    this.ref.detectChanges();
  }
  @Output() modelChange = new EventEmitter();

  @ViewChild('control') control: ElementRef;
  @ViewChild('formModel') formModel: NgModel;
  constructor(
    private ref: ChangeDetectorRef,
    deviceService: DeviceDetectorService) {
    this.isMobileOrTablet = !deviceService.isDesktop();
  }

  ngOnDestroy() {
    this.form?.removeControl(this.formModel);
  }

  ngAfterViewInit() {
    this.form?.addControl(this.formModel);
    this.onChanges();
    this.initialized = true;
    this.setOption();
    this.ref.detectChanges();
  }

  onFocus = () => {
    if (this.isMobileOrTablet) {
      $(this.control.nativeElement).trigger('blur');
    }
  }

  private onChanges = () => {
    this.date = this.pDate;
  }

  private setOption() {
    if (this.initialized) {
      ($(this.control.nativeElement) as any).datetimepicker({
        datepicker: this.type === 'datetime' || this.type === 'date',
        timepicker: this.type === 'datetime' || this.type === 'time',
        format: this.type === 'datetime' ? 'd/m/Y H:i' : (this.type === 'date' ? 'd/m/Y' : 'H:i'),
        step: 15,
        minDate: this.pMinDate || undefined,
        maxDate: this.pMaxDate || undefined,
        scrollMonth: false,
        scrollTime: false,
        scrollInput: false,
        onChangeDateTime: (date: any) => {
          if (!date && !this.date) {
            return;
          }
          if (this.type === 'datetime') {
            date = Date.toFormat(date, 'dd/MM/yyyy HH:mm');
          } else if (this.type === 'time') {
            date = Date.toFormat(date, 'HH:mm');
          } else {
            date = Date.toFormat(date, 'dd/MM/yyyy');
          }
          if (!this.equal(date, this.date)) {
            this.model = this.parse(date);
            this.modelChange.emit(this.parse(date));
            this.change.emit(this.parse(date));
            this.sdChange.emit(this.parse(date));
          }
          this.ref.detectChanges();
        }
      });
    }
  }

  private parse(date: any) {
    if (this.type === 'date') {
      return Date.parseFrom(date, 'dd/MM/yyyy');
    } else if (this.type === 'time') {
      return Date.parseFrom(date, 'HH:mm');
    }
    return Date.parseFrom(date, 'dd/MM/yyyy HH:mm');
  }
  private equal(date1: any, date2: any) {
    return Date.equal(this.parse(date1), this.parse(date2));
  }
}
